import React from 'react';
import { Mail, Phone, MapPin, Github, Linkedin, ExternalLink } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const Contact = () => {
  return (
    <section id="contact" className="section-padding py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="section-title text-4xl md:text-5xl font-bold text-white mb-4">
          <span className="text-cyan-400 font-mono text-lg">07.</span> Get In Touch
        </h2>
        <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mb-12"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Contact Information */}
          <Card className="glass-card bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl overflow-hidden hover:border-cyan-400/30 transition-all duration-300">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-white mb-6">
                Contact Information
              </h3>
              <div className="space-y-4">
                <a
                  href="mailto:ahmetogulcancankaya@gmail.com"
                  className="flex items-center gap-4 text-gray-300 hover:text-cyan-400 transition-colors duration-300 group"
                >
                  <div className="p-3 bg-cyan-500/10 rounded-lg border border-cyan-400/20 group-hover:bg-cyan-500/20 transition-colors duration-300">
                    <Mail className="w-5 h-5 text-cyan-400" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-400">Email</p>
                    <p className="font-medium">ahmetogulcancankaya@gmail.com</p>
                  </div>
                </a>

                <div className="flex items-center gap-4 text-gray-300">
                  <div className="p-3 bg-cyan-500/10 rounded-lg border border-cyan-400/20">
                    <Phone className="w-5 h-5 text-cyan-400" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-400">Phone</p>
                    <p className="font-medium">+90 530 423 5813 (Turkey)</p>
                    <p className="font-medium">+40 754 536 299 (Romania)</p>
                  </div>
                </div>

                <div className="flex items-center gap-4 text-gray-300">
                  <div className="p-3 bg-cyan-500/10 rounded-lg border border-cyan-400/20">
                    <MapPin className="w-5 h-5 text-cyan-400" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-400">Location</p>
                    <p className="font-medium">Bucharest, Romania</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Social Links */}
          <Card className="glass-card bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl overflow-hidden hover:border-cyan-400/30 transition-all duration-300">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-white mb-6">Social Links</h3>
              <div className="space-y-4">
                <a
                  href="https://github.com/AhmetOgulcanCankaya"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between gap-4 text-gray-300 hover:text-cyan-400 transition-colors duration-300 group"
                >
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-cyan-500/10 rounded-lg border border-cyan-400/20 group-hover:bg-cyan-500/20 transition-colors duration-300">
                      <Github className="w-5 h-5 text-cyan-400" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-400">GitHub</p>
                      <p className="font-medium">AhmetOgulcanCankaya</p>
                    </div>
                  </div>
                  <ExternalLink className="w-5 h-5" />
                </a>

                <a
                  href="https://www.linkedin.com/in/ahmet-ogulcan-cankaya/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between gap-4 text-gray-300 hover:text-cyan-400 transition-colors duration-300 group"
                >
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-cyan-500/10 rounded-lg border border-cyan-400/20 group-hover:bg-cyan-500/20 transition-colors duration-300">
                      <Linkedin className="w-5 h-5 text-cyan-400" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-400">LinkedIn</p>
                      <p className="font-medium">ahmet-ogulcan-cankaya</p>
                    </div>
                  </div>
                  <ExternalLink className="w-5 h-5" />
                </a>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Footer */}
        <div className="mt-12 text-center">
          <p className="text-gray-400">
            <span className="text-cyan-400 font-mono">&lt;/&gt;</span> Designed & Built by Ahmet Oğulcan Çankaya
          </p>
          <p className="text-gray-500 text-sm mt-2">
            © {new Date().getFullYear()} All rights reserved.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;